var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B6ACA2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.983 7.471h-3.236v1.92h3.236c.962 0 1.709.492 1.709.915v8.514c0 .423-.747.914-1.71.914H3.753c-.963 0-1.71-.491-1.71-.914v-8.514c0-.423.747-.914 1.71-.914h3.235v-1.92H3.752c-2.035 0-3.63 1.245-3.63 2.834v8.514c0 1.59 1.595 2.835 3.63 2.835h12.231c2.035 0 3.629-1.245 3.629-2.835v-8.514c0-1.59-1.594-2.835-3.63-2.835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.026 4.786a.957.957 0 0 0 .679-.282l1.202-1.202v9.767a.96.96 0 1 0 1.92 0V3.237l1.267 1.267a.957.957 0 0 0 1.357 0 .96.96 0 0 0 0-1.357L10.585.28A.956.956 0 0 0 9.907 0h-.015a.956.956 0 0 0-.679.28L6.347 3.148a.96.96 0 0 0 .68 1.639z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.f70c976d00eb61af689b4272fc952968.svg";
export { ForwardRef as ReactComponent };